import { focusAttempt } from "./focusAttempt.mjs";
export function focusFirstDescendant(element) {
  for (let i = 0; i < element.childNodes.length; i++) {
    const child = element.childNodes[i];
    if (focusAttempt(child) || focusFirstDescendant(child)) {
      return true;
    }
  }
  return false;
}
